import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";

export default function ModalWrapper({
	open,
	onClose,
	closeable = true,
	children,
	width = "sm:max-w-sm sm:w-full",
}) {
	const [initOpen, setInitOpen] = useState(open);
	
	useEffect(()=>{setInitOpen(open)}, [open])
	
	if(!initOpen) return null

	
	console.log('modal wrapper')
 	return (
			<div className="relative z-20">
				<div className="fixed inset-0 bg-gray-800 bg-opacity-75 transition-opacity" />
				<div className="fixed z-10 inset-0 overflow-y-auto">
					<div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
							<div
								className={
									`relative bg-gray-900 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:p-6 ` +
									width
								}
							>
								{closeable && (
									<div className="ml-3 flex h-7 items-right justify-end">
										<button
											type="button"
											className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-main-500"
											onClick={() => {onClose(false); setInitOpen(false)}}
										>
											<span className="sr-only">Close panel</span>
											<XIcon className="h-6 w-6" aria-hidden="true" />
										</button>
									</div>
								)}

								<div>
									<div className="mt-3 sm:mt-5">
										<div className="mt-2">{children}</div>
									</div>
								</div>
							</div>
					</div>
				</div>
			</div>
	);
}
